module.exports = __webpack_public_path__ + "static/media/resillience.85533f8b.png";